import React from 'react'
import { sponsorData } from '../data/sponsorData'

export const SponsorsSection: React.FC = () => {
  return (
    <div className="mt-8 sm:mt-12 mb-8 sm:mb-12 bg-white rounded-lg shadow-lg p-4 sm:p-6">
      <h2 className="text-2xl sm:text-3xl font-serif text-[#3C2416] mb-6 sm:mb-8 text-center">
        Our Sponsors
      </h2>

      {sponsorData.map((tier) => {
        // Only show tiers that have sponsors
        if (tier.sponsors.length === 0) return null

        return (
          <div key={tier.name} className="mb-8 sm:mb-10">
            <h3 className="text-xl sm:text-2xl font-serif text-[#A6410A] mb-4 sm:mb-6 text-center">
              {tier.name} Sponsors
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
              {tier.sponsors.map((sponsor) => (
                <a
                  key={sponsor.name}
                  href={sponsor.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center p-3 sm:p-4 bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer group"
                >
                  <div className="h-20 sm:h-24 w-full flex items-center justify-center mb-2 sm:mb-3">
                    {sponsor.logo ? (
                      <img
                        src={sponsor.logo}
                        alt={`${sponsor.name} logo`}
                        className={`max-h-full max-w-full object-contain transition-transform duration-300 ${
                          sponsor.name === 'Quilt Health'
                            ? 'scale-[3.5] group-hover:scale-[3.7]'
                            : 'group-hover:scale-105'
                        }`}
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-200 rounded flex items-center justify-center">
                        <span className="text-gray-400 text-xs sm:text-sm">
                          Logo
                        </span>
                      </div>
                    )}
                  </div>
                  <p className="text-[#3C2416] font-medium text-center text-sm sm:text-base">
                    {sponsor.name}
                  </p>
                </a>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
